import { useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import SelectNonEmployeeDrawer from "./SelectNonEmployeeDrawer/SelectNonEmployeeDrawer";
import TravelerPickerSelectNonEmployeeContent from "./TravelerPickerSelectNonEmployeeContent";
import { FormValues } from "./types";

const setValueConfig = {
  shouldDirty: true,
  shouldTouch: true,
};

export default function TravelerPickerSelectNonEmployee() {
  const [isVisible, setIsVisible] = useState(false);
  const { control, setValue } = useFormContext<FormValues<any>>();
  const [initialNonEmployee, employees] =
    useWatch({ control, name: ["nonEmployee", "employees"] }) || [];

  return (
    <>
      <TravelerPickerSelectNonEmployeeContent
        onOpenNonEmployeePicker={() => setIsVisible(true)}
      />
      {isVisible && (
        <SelectNonEmployeeDrawer
          isVisible
          onClose={() => setIsVisible(false)}
          onSubmit={(values) => setValue("nonEmployee", values, setValueConfig)}
          employees={employees}
          initialNonEmployeeValue={initialNonEmployee}
        />
      )}
    </>
  );
}
